import { useAuthStore } from "@/domains/auth/store/auth.store";

export async function bootstrapAuth(): Promise<void> {
  const auth = useAuthStore();

  await auth.initialize();
}
